import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

export const getPermissionsList = async (token) => {
    log("welcome in getPermissionsList from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/getPermissionsListApi'
        const result = await axios.get(url, { headers: headers })
        log("result.data din axios getPermissionsList")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getPermissionsList")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading permissions list" }
    }
}

export const getRolePermissions = async (token, roleId) => {
    log("welcome in getRolePermissions from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/getRolePermissionsApi'
        const params = { role_id: roleId }
        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getRolePermissions")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getRolePermissions")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading role permissions" }
    }
}

export const updateRolePermissions = async (token, roleId, permissionIds) => {
    log("welcome in updateRolePermissions from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/updateRolePermissionsApi'
        const params = { role_id: roleId, permission_ids: permissionIds }
        const result = await axios.post(url, params, { headers: headers })
        log("result.data din axios updateRolePermissions")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in updateRolePermissions")
        log(err)
        error.value = err.message
        return { error: true, message: "Error updating role permissions" }
    }
}

export const getCurrentUserPermissions = async (token) => {
    log("welcome in getCurrentUserPermissions from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/getCurrentUserPermissionsApi'
        const result = await axios.get(url, { headers: headers })
        log("result.data din axios getCurrentUserPermissions")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getCurrentUserPermissions")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading user permissions" }
    }
}

const usePermissionsAPI = () => {
    return {
        error,
        getPermissionsList,
        getRolePermissions,
        updateRolePermissions,
        getCurrentUserPermissions
    }
}

export default usePermissionsAPI
